import {
  QuestionnaireResponsePair,
  UserPlacement,
} from "@/types/questionnaire/models"
import { OptionPlacement } from "./placementUtils"

export const getOptionsPlacements = (
  question: QuestionnaireResponsePair,
  userPlacement?: UserPlacement | null,
): OptionPlacement[] => {
  const userOptionsPlacements = userPlacement?.optionsPlacements

  if (userOptionsPlacements && userOptionsPlacements.length) {
    return userOptionsPlacements
  }

  return (question.pdfPlacement?.extraction?.optionsWithBbox || [])
    .filter((o) => !!o?.bbox)
    .map((o) => ({
      text: o.text,
      x: o.bbox.x,
      y: o.bbox.y,
      width: o.bbox.w,
      height: o.bbox.h,
      page: o.bbox.page,
    }))
}

export const updateOptionPlacement = (
  placements: OptionPlacement[],
  optionIndex: number,
  updates: Partial<OptionPlacement>,
): OptionPlacement[] => {
  return placements.map((opt, idx) =>
    idx === optionIndex ? { ...opt, ...updates } : opt,
  )
}
